import script from "./videoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./videoDialog.vue?vue&type=script&setup=true&lang=js"

import "./videoDialog.vue?vue&type=style&index=0&id=1eca8ca0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eca8ca0"]])

export default __exports__